import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { reactClass } from '../../utils'

export const PlaceholderContainer = styled.div`
  width: 100%;
  margin-bottom: ${Spacing.S12};

  .${reactClass('loading-placeholder-header')} + .${reactClass('loading-placeholder-line')} {
    margin-top: 1rem;
  }

  .${reactClass('loading-placeholder-header')}:first-of-type,
    .${reactClass('loading-placeholder-line')}:first-of-type,
    .${reactClass('loading-placeholder-thumb')}:first-of-type {
    margin-top: 0;
  }

  .${reactClass('loading-placeholder-line')}:last-of-type {
    margin-bottom: 0;
  }
`
